import {Fragment, UUID} from '@nh/angular-tses';
import {DASFragmentType} from './das-fragment-type';

export enum LinkedDepartureRelationshipType {
  ASSOCIATED = 'ASSOCIATED',
  SIMILAR = 'SIMILAR',
  REPEATED = 'REPEATED',
}

/**
 * A class representing a Location Fragment used for displaying locational information.
 *
 * @field value {string}   The raw Location
 */
export class LinkedDepartureFragment extends Fragment {
  /**
   * Static helper to return an empty linked departure fragment.
   *
   * @returns {LinkedDepartureFragment}   The linked departure fragment
   */
  public static empty(): LinkedDepartureFragment {
    return new LinkedDepartureFragment(null);
  }

  constructor(
    id: UUID,
    public targetDepartureId: UUID = null,
    public otherLinkFragmentId: UUID = null,
    public linkOrigin: boolean = false,
    public twoWayLink: boolean = false,
    public departureIdNum: number = null,
    public revision: number = null,
    public departureTitle: string = '',
    public workflowState: string = '',
    public relationshipType: LinkedDepartureRelationshipType = null,
    public comment: string = '',
    public deleted: boolean = false
  ) {
    super(id, DASFragmentType.LINKED_DEPARTURE, []);
  }

  /**
   * @inheritDoc
   */
  public split(offset: number): LinkedDepartureFragment {
    return null;
  }
}

/**
 * Deserialiser function for Linked Departure Fragments.
 *
 * @param json {any}                JSON object to deserialise
 * @returns    {LinkedDepartureFragment}   Deserialised Linked Departure Fragment Object
 */
export function deserialiseLinkedDepartureFragment(json: any): LinkedDepartureFragment {
  return new LinkedDepartureFragment(
    UUID.orThrow(json.id),
    UUID.orThrow(json.targetDepartureId),
    UUID.orThrow(json.otherLinkFragmentId),
    json.linkOrigin,
    json.twoWayLink,
    json.departureIdNum,
    json.revision,
    json.departureTitle,
    json.workflowState,
    json.relationshipType,
    json.comment,
    json.deleted
  );
}
